import React, {useState, useEffect, useContext} from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CapsuleVideo from "../components/capsules/capsuleVideo";
import Button from '@mui/material/Button';
import AjouterCapsuleForm from "../components/forms/AjouterCapsuleForm"
import { getAllCapsules, createCapsule,deleteCapsuleById } from '../services/requestHandler';
import { KeycloackContext } from '../services/keycloakProvider';
const theme = createTheme();

export default function Capsules() {
  const { isAdminRole } = useContext(KeycloackContext)

  const [videos, setVideos] = useState([{
    id: 0,
    arrayLink: "",
    contenu: "",
    arrayLink_en: "",
    contenu_en: "",
    no_video: 0,
  }])
  const [createFormOpen, setCreateFormOpen] = useState(false);

  async function getCapsule() {
    const data = await getAllCapsules();
    setVideos(data);
  }

  useEffect(()=> {
    getCapsule();
  }, []);

  const handleDeleteVideo = (videoDeleteId) => {
    deleteCapsuleById(videoDeleteId);
  }

  const handleCreateClick = (newVideoInfos) => {
    if((newVideoInfos.contenu !== "" && newVideoInfos.arrayLink !== "") | (newVideoInfos.contenu_en !== "" && newVideoInfos.arrayLink_en !== ""))
    {
      createCapsule(newVideoInfos)
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <main style={{display: "grid", justifyContent: "center", justifyItems: "center"}}>
          <Typography
            component="h1"
            variant="h2"
            align="center"
            color="text.primary"
            gutterBottom
            marginTop="25px"
          >
            Capsules
          </Typography>
        <Container sx={{ py: 4 }} maxWidth="md">
          <Grid container spacing={2}>
            {videos.map((video) => (
              <Grid item key={video.id} xs={2} sm={2} md={6}>
                <CapsuleVideo video={video} handleDelete={handleDeleteVideo}/>
              </Grid>
            ))}
          </Grid>
        </Container>
        <div style={{marginBottom: " 9rem "}}>
          {isAdminRole && <Button variant="contained" sx={{backgroundColor: "#307B5B", "&:hover": {backgroundColor: "#8EBF55", color: "black", fontWeight: "bold"}}} onClick={() => setCreateFormOpen(true)} style={{width: "12rem", marginBottom: "9rem"}}> Ajouter Capsule </Button>}
        </div>
        <AjouterCapsuleForm
            open={createFormOpen}
            setOpen={setCreateFormOpen}
            onConfirm={handleCreateClick}
          />
      </main>
    </ThemeProvider>
  );
}